import { RefObject, useEffect } from "react";

export const handlePlayPauseVisibility = (
  videoRef: RefObject<HTMLVideoElement | null>,
  videoSrc: { cloudinaryVideo: { src: string; breakpoint: number }[] } | undefined,
  setShowPlayPause: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  useEffect(() => {
    const updatePlayPauseVisibility = () => {
      if (videoSrc?.cloudinaryVideo?.length) {
        if (videoRef?.current) {
          const duration = videoRef.current.duration || 0;
          setShowPlayPause(duration > 5);
        }
      }
    };

    const handleLoadedMetadata = () => {
      updatePlayPauseVisibility();
    };

    const videoElement = videoRef.current;

    if (videoElement) {
      videoElement.addEventListener("loadedmetadata", handleLoadedMetadata);
    }
    window.addEventListener("resize", updatePlayPauseVisibility);

    updatePlayPauseVisibility();

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
      }
      window.removeEventListener("resize", updatePlayPauseVisibility);
    };
  }, [videoRef, videoSrc, setShowPlayPause]);
};
